const componentControllers = import.meta.glob(
  ["./**/*_controller.js", "!./blocks/*_controller.js"],
  { eager: true },
)

export default componentControllers
